/* global axios */
import ApiClient from './ApiClient';

class KnowledgeBaseAPI extends ApiClient {
  constructor() {
    super('knowledge_base', { accountScoped: true });
  }

  // ---- 知识库条目 CRUD ----
  getItems() {
    return axios.get(this.url);
  }

  createItem(data) {
    return axios.post(this.url, data);
  }

  updateItem(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  deleteItem(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // ---- 检索测试 / 抓取 / 上传 ----
  testSearch(query) {
    return axios.get(`${this.url}/search`, { params: { q: query } });
  }

  crawlPage(url) {
    return axios.post(`${this.url}/crawl`, { url });
  }

  uploadDocument(data) {
    return axios.post(`${this.url}/documents`, data);
  }

  // ---- 待审知识建议 ----
  getSuggestions() {
    return axios.get(`${this.url}/suggestions`);
  }

  adoptSuggestion(id) {
    return axios.post(`${this.url}/suggestions/${id}/adopt`);
  }

  rejectSuggestion(id) {
    return axios.post(`${this.url}/suggestions/${id}/reject`);
  }

  // ---- 数字人人设与状态 ----
  getPersona() {
    return axios.get(`${this.url}/persona`);
  }

  updatePersona(data) {
    return axios.put(`${this.url}/persona`, data);
  }

  getDigitalWorkerStatus() {
    return axios.get(`${this.url}/digital_worker_status`);
  }

  // ---- 质量与标注 ----
  getStats() {
    return axios.get(`${this.url}/stats`);
  }

  getAiEvents() {
    return axios.get(`${this.url}/ai_events`);
  }

  submitFeedback(data) {
    return axios.post(`${this.url}/feedback`, data);
  }
}

export default new KnowledgeBaseAPI();
